import React from "react";
import { SECTIONS, YouthHub } from "./LeagueHub";
import { useSectionParam } from "../utils/useSectionParam";

/** Youth league hub: same fixtures, standings and stats views, loading the `youth_*` tables. */
const YouthLeague = () => {
  const [section, setSection] = useSectionParam(SECTIONS.map((s) => s.key));
  return <YouthHub section={section} onSectionChange={setSection} />;
};

export default YouthLeague;
